<button mat-button disabled id="sh-disabled-action-button">
	<mat-icon class="prism-md-sharp more_vert"></mat-icon>
</button>
